import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { CLINIC, CATEGORIES } from "@/lib/site";

const QUICK = [
  { to: "/about", label: "About Dr. Vipul" },
  { to: "/treatments", label: "Treatments" },
  { to: "/conditions", label: "Conditions Treated" },
  { to: "/pricing", label: "Packages & Pricing" },
  { to: "/gallery", label: "Clinic Gallery" },
  { to: "/articles", label: "Health Articles" },
];

export default function Footer() {
  return (
    <footer className="bg-teal-obsidian text-alabaster/80 grain-dark">
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Logo light />
            <p className="mt-5 text-sm leading-relaxed text-alabaster/60 max-w-xs">
              Gomti Nagar's trusted destination for physiotherapy and rehabilitation — pain
              management, sports injury recovery, neuro rehab and post-surgical care under one roof.
            </p>
            <p className="mt-6 font-display italic text-2xl text-gold">Reclaim Your Life.</p>
          </div>

          <div className="lg:col-span-2">
            <p className="mono-label text-gold">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {QUICK.map((q) => (
                <li key={q.to}>
                  <Link
                    to={q.to}
                    data-testid={`footer-link-${q.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm hover:text-gold transition-colors duration-200"
                  >
                    {q.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="mono-label text-gold">Programmes</p>
            <ul className="mt-4 space-y-2.5">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link
                    to="/treatments"
                    data-testid={`footer-link-cat-${c.id}`}
                    className="text-sm hover:text-gold transition-colors duration-200 inline-flex items-center gap-1"
                  >
                    {c.label} <ArrowUpRight size={12} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="mono-label text-gold">Visit Us</p>
            <ul className="mt-4 space-y-3.5 text-sm">
              <li className="flex gap-3">
                <MapPin size={16} className="shrink-0 mt-0.5 text-gold" />
                <a href={CLINIC.mapsUrl} target="_blank" rel="noreferrer" data-testid="footer-address-link" className="hover:text-gold transition-colors">
                  {CLINIC.address}
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <Phone size={16} className="shrink-0 text-gold" />
                <a href={CLINIC.phoneHref} data-testid="footer-phone-link" className="hover:text-gold transition-colors">
                  {CLINIC.phone}
                </a>
              </li>
              <li className="flex gap-3 items-center">
                <Mail size={16} className="shrink-0 text-gold" />
                <a href={`mailto:${CLINIC.email}`} data-testid="footer-email-link" className="hover:text-gold transition-colors">
                  {CLINIC.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Clock size={16} className="shrink-0 mt-0.5 text-gold" />
                <span>
                  Mon – Sat: 9:00 AM – 9:00 PM<br />
                  Sunday: 9:00 AM – 1:00 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-alabaster/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-alabaster/40">
          <p>© {new Date().getFullYear()} Kamana Physiotherapy &amp; Rehab Center, Gomti Nagar, Lucknow.</p>
          <p className="mono-label !text-[9px] text-alabaster/40">Movement Is Medicine</p>
        </div>
      </div>
    </footer>
  );
}
